import {IoMdPin} from 'react-icons/io'
import Text from '@components/V3/Text'
import useOrder from '@page-components/TrackV2/hooks/useOrder.main'
import {useTranslation} from 'next-i18next'

export default function Table() {
  const {order} = useOrder()
  const {t} = useTranslation('tracking', {keyPrefix: 'table'})

  if (order.deliveryType !== 'serve') {
    return null
  }

  return (
    <div className="flex items-center space-x-2">
      <IoMdPin size={20} />
      <div className="flex-1">
        <Text type="body">{t('title', {tableName: order.tableName})}</Text>
      </div>
    </div>
  )
}
